/**
 * Client-side logger.
 *
 * Wraps console methods so that the output layer can be swapped out in future
 * (e.g. forwarding to Azure Application Insights) without touching call sites.
 *
 * In production, only error / warn are emitted. Debug messages are suppressed.
 */

const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  error: (message: string, ...args: unknown[]): void => {
    // eslint-disable-next-line no-console
    console.error(`[ERROR] ${message}`, ...args);
  },
  warn: (message: string, ...args: unknown[]): void => {
    // eslint-disable-next-line no-console
    console.warn(`[WARN] ${message}`, ...args);
  },
  info: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.info(`[INFO] ${message}`, ...args);
    }
  },
  debug: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },
};
